import React from 'react';
import { Heading1, Heading3, Paragraph } from '../../components/typography';
import { Row, Col, Container } from '../../components/grid';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import TheVideoPlayer from '../../components/TheVideoPlayer';

export default () => (
  <SidemenuLayout menuPicker="Infosider" activeSidemenu="Video">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>
            Forskel på fadølsglas
          </Heading1>
          <Paragraph>
            Der er stor forskel på kvalitetsglas fra skafte.dk og almindelige plastikglas fra supermarkedet
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container mb>
      <Row>
        <Col xs={12} padding="0">
          <TheVideoPlayer url="5zCqQ9c7OoE" thumbnail="forskel-fadoelsglas" />
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading3>
            Udskrift af video
          </Heading3>
          <Paragraph>
            Kvalitetsglas fra skafte.dk vs. Almindelige plastikglas fra supermarkedet.
          </Paragraph>
          <Paragraph>
            Der er stor forskel på om man bruger kvalitetsglas
            til fadøl eller om man køber nogle billigt i
            dagligvarehandlen.
            Der er meget stor forskel på hvor nemt det er at hælde op i
            glassene uden at det skummer for meget.
          </Paragraph>
          <Paragraph>
            Det er vigtigt når man tapper fadøl,
            at man hiver håndtaget fremad og helt ned i vandret
            i ét snuptag. Hold glasset på skrå,
            så fadøllet løber ned af siden.
            Læg mærke til at øllet løber helt klart ud af hanen.
            Der er ingen problemer med at fylde glasset op og få
            perfekt skum.
          </Paragraph>
          <Paragraph>
            Her ses det andet glas, købt i det lokale supermarked.
            Igen, håndtaget er vippet helt ned og glasset er på skrå.
            Læg mærke til at øllet løber helt klart ud af hanen,
            men det bliver alligevel skum det hele og det er udelukkende pga. glasset.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
